import { render, staticRenderFns } from "./routerList.vue?vue&type=template&id=6a55d94d&scoped=true&"
import script from "./routerList.vue?vue&type=script&lang=js&"
export * from "./routerList.vue?vue&type=script&lang=js&"
import style0 from "./routerList.vue?vue&type=style&index=0&id=6a55d94d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a55d94d",
  null
  
)

export default component.exports